module.exports = __webpack_public_path__ + "img/Speaker=Russell Sng.e4919051.png";